module.exports = __webpack_public_path__ + "static/Twitch_Polls-9aa4584c766d62c67108f1e927fb3502.gif";